module.exports = __webpack_public_path__ + "static/media/pencil.ed91dbde.svg";